import React from 'react'
import { useState } from 'react'
import Modal from 'react-modal';
import { MdClose} from 'react-icons/md'
import NotFound from "../img/NotFound.svg";

const customStyles = {
    content: {
      top: '55%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1
    },
  };

Modal.setAppElement('#root');

const OrderDetail = ({data}) => {
    const [itemDetail,setItemDetail] = useState(null)

    let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal(item) {
    setItemDetail(item)
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
    {data && data.length > 0 ?(
        data.map((item) => (
        <>

        <tbody>
                <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <td scope="row" className="py-4 px-6 font-medium text-gray-900  dark:text-white">
                        {item.id}
                    </td>
                    <td className="py-4 px-6">
                        {item.status}
                    </td>
                    <td className="py-4 px-6">
                    {new Date(item.date).toLocaleDateString("en-US")}
                    </td>
                    <td className="py-4 px-6">
                        ${item.total + 2.5}
                    </td>
                    <td className="py-4 px-6">
                        <button className='bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded' onClick={()=>openModal(item.items)}>Detail</button>
                        {/* <button  onClick={()=>setShowDetail(!showDetail)}> Detail</button> */}
                    </td>
                </tr>
                </tbody>
            </>
       ))         
    ):(
      <div className="w-full flex flex-col items-center justify-center">
        <img src={NotFound} className="h-340" />
        <p className="text-xl text-headingColor font-semibold my-2">
          Items Not Available
        </p>
      </div>
    )}

<Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        
        contentLabel="Example Modal"
      >
        <div className=' z-50 flex justify-between border-b-4 border-gray-200 p-4'>
            <h2 className='text-gray-500'>Details</h2>
            <button onClick={closeModal}><MdClose className='text-textColor text-2xl  cursor-pointer'/> </button>
        </div>
        {/* <div>Details</div> */}
        <div class="w-full flex items-center  my-2 scroll-smooth overflow-x-hidden overflow-hidden overscroll-none  shadow-md sm:rounded-lg">
                        <table class=" text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" class="py-3 px-6">
                                        Image
                                    </th>
                                    <th scope="col" class="py-3 px-6">
                                        Product
                                    </th>
                                    <th scope="col" class="py-3 px-6">
                                        Qty
                                    </th>
                                    <th scope="col" class="py-3 px-6">
                                        Price
                                    </th>
                                   
                                </tr>
                            </thead>
                            <tbody className='overflow-y-scroll scrollbar-none'>
                                {itemDetail && itemDetail.map((it)=>(
                                    <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                    <td class="p-4 w-32">
                                        <img src={it.imageUrl} className=' w-24 h-24' alt="" />
                                    </td>
                                    <td class="py-4 px-6 font-semibold text-gray-900 dark:text-white">
                                       {it.title}
                                    </td>
                                    <td class="py-4 px-6">
                                        <div class="flex items-center space-x-3">
                                            <button class="inline-flex items-center p-1 text-sm font-medium text-gray-500 bg-white rounded-full border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700" type="button">
                                                <span class="sr-only">Quantity button</span>
                                                <svg class="w-4 h-4" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
                                            </button>
                                            <div>
                                                <input type="text"  id="first_product" class="bg-gray-50 w-14 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block px-2.5 py-1 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder={it.qty} required />
                                            </div>
                                            <button class="inline-flex items-center p-1 text-sm font-medium text-gray-500 bg-white rounded-full border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700" type="button">
                                                <span class="sr-only">Quantity button</span>
                                                <svg class="w-4 h-4" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                                            </button>
                                        </div>
                                    </td>
                                    <td class="py-4 px-6 font-semibold text-gray-900 dark:text-white">
                                        {it.price}
                                    </td>
                                    {/* <td class="py-4 px-6">
                                        <a href="#" class="font-medium text-red-600 dark:text-red-500 hover:underline">Remove</a>
                                    </td> */}
                                </tr>
                            

                                ))}
                                
                            
                            </tbody>
                        </table>
                    </div>
      </Modal>


    </>
                
  )
}

export default OrderDetail